import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const CreateNewEntityButton = ({
  onClick,
  entityName,
  testId,
  disabled,
  variant = 'contained',
  ...rest
}: {
  entityName: string;
  onClick: () => void;
  testId?: string;
  disabled?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
}) => {
  return (
    <Button
      {...rest}
      variant={variant}
      data-testid={testId || 'page-create-button'}
      style={disabled ? {} : { backgroundColor: '#2196F3' }}
      onClick={onClick}
      sx={{ fontWeight: '700' }}
      disabled={disabled}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <AddIcon /> Add {entityName}
      </div>
    </Button>
  );
};
